import { getPlatform } from 'utils/platform'

export const BitcoinSuccessScreenRecurringInvestmentCta = {
  segment_call_type: 'track',
  feature: 'Bitcoin Onboarding',
  event_description: 'Success Recurring Investment Cta tapped',
  platforms: getPlatform(),
  object_name: 'bitcoinSuccessScreenRecurringInvestmentCta',
  screen: 'bitcoinOnboardingSuccess',
  screen_name: 'Bitcoin Success',
  destination: 'recurring',
  cta_title: 'Set up Recurring',
}

export const BitcoinSuccessScreenOneTimeInvestmentCta = {
  segment_call_type: 'track',
  feature: 'Bitcoin Onboarding',
  event_description: 'Success One Time Investment Cta tapped',
  platforms: getPlatform(),
  object_name: 'bitcoinSuccessScreenOneTimeInvestmentCta',
  screen: 'bitcoinOnboardingSuccess',
  screen_name: 'Bitcoin Success',
  destination: 'one-time',
  cta_title: 'One-Time investment',
}
